export enum TreatedStatusFilter {
    both = 'both',
    toTreat = 'toTreat',
    treated = 'treated',
}
